/* eslint-disable react/no-unused-prop-types */
import React from "react";
import PropTypes from "prop-types";

const Tab = () => {
  return <></>;
};

Tab.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  selectedTabId: PropTypes.string,
  title: PropTypes.node,
  onClick: PropTypes.func
};
Tab.defaultProps = {
  disabled: false,
  selectedTabId: null,
  title: null,
  onClick: null
};

export default Tab;
